<!-- add-goal-dialog.component.html -->
<div class="dialog-container">
  <!-- Header ---------------------------------------------------->
  <div class="dialog-header">
    <div class="user-edit-icon">
      <img src="assets/images/target.png" class="dialog-icon" alt="Target icon" />
    </div>
    <h2 class="dialog-title">{{dialogTitle}}</h2>
    <button mat-icon-button class="close-button" (click)="onCancel()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Form ------------------------------------------------------>
  <form class="dialog-form" #f="ngForm">
    <!-- Goal description -->
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Goal Description</mat-label>
      <textarea matInput rows="2"
                required
                [(ngModel)]="goal.title"
                name="title"></textarea>
    </mat-form-field>

    <!-- Target value (value + unit) -->
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Target Value</mat-label>
      <input matInput
             required
             [(ngModel)]="targetInput"
             name="targetInput"
             autocomplete="off" />
    </mat-form-field>

    <!-- Current progress (optional) -->
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Current Progress</mat-label>
      <input matInput
             [(ngModel)]="currentInput"
             name="currentInput"
             autocomplete="off"  />
    </mat-form-field>

    <!-- Actions ------------------------------------------------->
    <div class="dialog-actions">
      <button mat-stroked-button color="primary" (click)="onCancel()">Cancel</button>
      <button mat-flat-button color="primary"
              [disabled]="!goal.title || !targetInput"
              (click)="onSave()">Save</button>
    </div>
  </form>
</div>
